import { PayloadAction, createAsyncThunk, createEntityAdapter, createSlice } from "@reduxjs/toolkit";
import { RootState } from "../../app/store";
import * as roleService from '../../service/role.service'
import { Role, RoleRequest } from "../../service/model/role.model";
import { showNotification } from "../alerts/alert.slice";
import { NotificationType } from "../../shared/enums";
import { getAxiosErrorMessage } from "../../service/axios/axios.call.service";

export interface RoleState {
    isLoading: boolean;
}

const rolesAdapter = createEntityAdapter({
    selectId: (role: Role) => role.id,
    sortComparer: (a, b) => a.name?.localeCompare(b.name),
  })
  
export const initialState = rolesAdapter.getInitialState({
    isLoading: false,
} as RoleState);

export const fetchRoles = createAsyncThunk<Role[]>(
    'roles/all',
    async (_, {rejectWithValue}) => {
        return roleService.getRoles().catch((errors) => {
            return rejectWithValue(errors);
        })
    }
);

export const updateRole = createAsyncThunk<Role, RoleRequest>(
    'roles/update',
    async (request, { rejectWithValue, dispatch }) => {
        return roleService.updateRole(request)
        .then((response) => {
            dispatch(
                showNotification({
                    message: "Role updated successfully",
                    type: NotificationType.Success,
                })
            );
            // dispatch(fetchRoles());
            return response;
        }).catch((errors) => {
            dispatch(
                showNotification({
                    message: getAxiosErrorMessage(errors.response),
                    type: NotificationType.Error,
                })
            );
            return rejectWithValue(errors);
        });
    }
);

const roleSlice = createSlice({
    name: 'roles',
    initialState,
    reducers: {},
    extraReducers: (builder) => {
        builder
        .addCase(fetchRoles.pending, (state) => {
            state.isLoading = true;
        })
        .addCase(fetchRoles.fulfilled, (state, action: PayloadAction<Role[]>) => {
            rolesAdapter.setAll(state, action.payload);
            state.isLoading = false;
        })
        .addCase(fetchRoles.rejected, (state) => {
            state.isLoading = false;
        })
        .addCase(updateRole.pending, (state) => {
            state.isLoading = true;
        })
        .addCase(updateRole.fulfilled, (state, action: PayloadAction<Role>) => {
            rolesAdapter.upsertOne(state, action.payload);
            state.isLoading = false;
        })
        .addCase(updateRole.rejected, (state) => {
            state.isLoading = false;
        });
    }
});

export const {
    selectAll: selectRoles,
    selectById: selectRoleById
} = rolesAdapter.getSelectors<RootState>((state) => state.roles);

export const roleActions = roleSlice.actions;

export const selectIsLoading = (state: RootState) => state.roles.isLoading;

export default roleSlice.reducer;